/**
 * Replace one vnode, found by CSS class, inside a rendered Mithril tree, in
 * place. Tasks 4.1 and 4.2.
 *
 * For components that build their markup inline in one `view()` expression --
 * `ComposerBody` and `ReplyPlaceholder` both do -- so there is no smaller method
 * to override. Copying the whole view would silently fall behind core; swapping
 * the one vnode keeps everything else core's.
 *
 * Replaces the FIRST match only, depth-first, and returns whether it found one,
 * so a core change that renames a class shows up in a test instead of silently
 * restoring whatever the class was hiding. `null` is an allowed replacement:
 * Mithril renders a null child as nothing, which is how an element is removed.
 */
export function replaceByClass(tree, className, replacement) {
  const children = childrenOf(tree);
  if (!children) return false;
  for (let i = 0; i < children.length; i++) {
    if (hasClass(children[i], className)) {
      children[i] = replacement;
      return true;
    }
    if (replaceByClass(children[i], className, replacement)) return true;
  }
  return false;
}

/**
 * Whole-word match against `attrs.className` (JSX) or `attrs.class`, so
 * `Post-avatar` does not match `Post-avatar-frame`.
 */
function hasClass(node, className) {
  const attrs = node?.attrs;
  const value = attrs?.className ?? attrs?.class;
  return typeof value === 'string' && value.split(/\s+/).includes(className);
}
function childrenOf(node) {
  if (Array.isArray(node)) return node;
  const children = node?.children;
  return Array.isArray(children) ? children : null;
}